import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useSocket } from "../../../utils/Socket.Provider";
import { IoSend } from "react-icons/io5";
import { BsSearch } from "react-icons/bs";
import {
  useGetConsultantProfileQuery,
  useGetConsultantRoomListQuery,
  useLazyGetMessageByRoomIdQuery,
} from "../../../redux/rtk/apiRtk";
import { Switch } from "antd";

const ConsultantChatBox = () => {
  const [getMessageByRoomId, { data: messagess }] =
    useLazyGetMessageByRoomIdQuery("");

  const { data: profile, isLoading } = useGetConsultantProfileQuery("");
  const [messages, setMessages] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [users, setUsers] = useState([]);

  const { data: userList, refetch } = useGetConsultantRoomListQuery("", {
    refetchOnFocus: true,
  });

  const { socket } = useSocket();
  const [message, setmessage] = useState("");
  const [isOnline, setisOnline] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    refetch();
    let intervalId;
    if (userList) {
      intervalId = setInterval(() => {
        refetch();
      }, 3000);
    }

    return () => {
      clearTimeout(intervalId);
    };
  }, [userList]);

  useEffect(() => {
    if (userList) {
      setUsers(userList);
      setFilteredUsers(userList);
    }
  }, [userList]);

  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (!searchQuery.trim()) {
        setFilteredUsers(users);
      } else {
        const filtered = users.filter((user) => {
          const fullName = `${user?.userProfile?.firstName || ""} ${
            user?.userProfile?.lastName || ""
          }`.toLowerCase();
          const lastMessage = user?.lastMessage?.data?.toLowerCase() || "";
          const query = searchQuery.toLowerCase();

          return fullName.includes(query) || lastMessage.includes(query);
        });
        setFilteredUsers(filtered);
      }
    }, 300); // 300ms debounce delay

    return () => clearTimeout(debounceTimer);
  }, [searchQuery, users]);

  useEffect(() => {
    socket.emit("join-chat-room", profile?._id);
  }, [isLoading, profile?._id]);

  useEffect(() => {
    if (messagess) {
      setMessages(messagess);

      setTimeout(() => {
        scrollToBottom();
      }, 500);
    }
  }, [messagess?.length, selectedProfile?.roomid]);
  // useEffect(() => {
  //   setTimeout(() => {
  //     scrollToBottom();
  //   }, 500);
  // }, [message?.length, messagess, selectedProfile?.roomid]);

  useEffect(() => {
    if (!socket) {
      return;
    }
    // socket.emit("status", profile?._id);

    socket.on("consultant-message", (data) => {
      if (selectedProfile?.roomid === data?.roomid) {
        setMessages((oldArray) => [...oldArray, data]);
      }
      // Update user list order when new message arrives
      setUsers((prevUsers) => {
        const updatedUsers = [...prevUsers];
        const userIndex = updatedUsers.findIndex(
          (user) => user.roomid === data.roomid
        );

        if (userIndex !== -1) {
          // Remove user from current position and add to top
          const [movedUser] = updatedUsers.splice(userIndex, 1);

          // Update last message and timestamp
          const updatedUser = {
            ...movedUser,
            lastMessage: {
              data: data?.data.trim(),
              isRead: false,
              createdAt: new Date().toISOString(),
            },
          };

          return [updatedUser, ...updatedUsers];
        }

        return updatedUsers;
      });

      scrollToBottom();
    });

    // socket.on('change-room-status', (data) => {
    //   console.log({ data });
    // })

    socket.on("status", (data) => {
      const isRoomId =
        data?.roomIds?.includes(selectedProfile?.roomid) ||
        data?.roomIds?.includes(selectedProfile?.userProfile?.user?._id);

      if (isRoomId) {
        setisOnline(data?.data);
      }
    });

    return () => {
      socket.off("consultant-message");
      socket.off("status");
      socket.off("consultant-list");
    };
  }, [profile?._id, socket, selectedProfile?.roomid]);

  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
  };
  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);

  const handelsubmit = () => {
    // 1. Validate input
    if (!message || !message.trim()) {
      console.log("Missing message", message);
      return; // Ignore empty or whitespace-only messages
    }

    if (!profile?._id || !selectedProfile?.roomid) {
      console.error("Missing required data for sending message");
      console.log({ profile, selectedRoomId: selectedProfile?.roomid });
      return; // Prevent sending if critical data is missing
    }

    const newMessage = {
      data: message.trim(),
      roomid: selectedProfile?.roomid,
      userid: profile?._id,
      createdAt: new Date().toISOString(),
    };

    setMessages((oldArray) => [...oldArray, newMessage]);

    // Update user list to move current conversation to top
    setUsers((prevUsers) => {
      const updatedUsers = [...prevUsers];
      const userIndex = updatedUsers.findIndex(
        (user) => user.roomid === selectedProfile?.roomid
      );

      if (userIndex !== -1) {
        // Remove user from current position and add to top
        const [movedUser] = updatedUsers.splice(userIndex, 1);

        // Update last message and timestamp
        const updatedUser = {
          ...movedUser,
          lastMessage: {
            data: message.trim(),
            isRead: false,
            createdAt: new Date().toISOString(),
          },
        };

        return [updatedUser, ...updatedUsers];
      }

      return updatedUsers;
    });

    socket.emit("consultant-message", newMessage);

    scrollToBottom();
    setmessage("");
    requestAnimationFrame(() => {
      textareaRef.current?.focus(); // keyboard remains open
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handelsubmit();
    }
    // Allow Shift+Enter for new lines - no preventDefault needed
  };
  return (
    <div className="chat-container flex flex-col md:flex-row bg-gradient-to-br from-gray-50 to-gray-100  rounded-lg shadow-lg h-screen overflow-hidden">
      {/* Left Sidebar - User List */}
      <div
        className={`w-full md:w-[350px] bg-white border-r border-gray-200 flex flex-col shadow-lg h-full max-h-full ${
          selectedProfile ? "hidden" : ""
        } md:block`}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-[#A40165] to-[#C41E3A] px-4 py-3 text-white flex-shrink-0">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold">Chats</h2>
          </div>
        </div>

        {/* Search Bar */}
        <div className="p-3 bg-white border-b border-gray-100 flex-shrink-0">
          <div className="relative">
            <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search conversations..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2 bg-gray-50 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#A40165] focus:bg-white transition-all border border-transparent focus:border-[#A40165]/20"
            />
          </div>
        </div>

        {/* User List */}
        <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 bg-gray-50/30 min-h-0">
          {filteredUsers?.length > 0 ? (
            filteredUsers.map((e, index) => {
              // socket.emit("join-chat-room", e?.roomid);

              const isSelected = selectedProfile?.roomid === e?.roomid;
              const item = e?.userProfile;

              return (
                <div
                  key={index}
                  onClick={async () => {
                    await getMessageByRoomId(e?.roomid);

                    setSelectedProfile(e);

                    // Reset unread count for selected conversation
                    setUsers((prevUsers) =>
                      prevUsers.map((user) =>
                        user.roomid === e?.roomid
                          ? {
                              ...user,
                              lastMessage: {
                                ...user.lastMessage,
                                isRead: true,
                              },
                            }
                          : user
                      )
                    );

                    setToggle(e?.isActive);
                    console.log(e);

                    // socket.emit("join-room", e?.roomid);
                    socket.emit("join-chat-room", e?.roomid);

                    // socket.emit("status", e?.userProfile?.user?._id);
                    socket.emit("status", {
                      id: e?.userProfile?.user?._id,
                      roomId: e?.roomid,
                    });

                    socket.emit("consultant-message-read-all", {
                      userId: profile?.user,
                      roomId: e?.roomid,
                      profileId: e?.userProfile?.user?._id,
                    });
                  }}
                  className={`flex items-center p-4 hover:bg-gradient-to-r hover:from-[#A40165]/8 hover:to-[#A40165]/4 cursor-pointer border-b border-gray-200/60 transition-all duration-200 ${
                    isSelected
                      ? "bg-gradient-to-r from-[#A40165]/15 to-[#A40165]/8 border-l-4 border-l-[#A40165] shadow-md"
                      : "hover:shadow-sm"
                  }`}
                >
                  <div className="relative flex-shrink-0">
                    <img
                      src={item?.profilePic?.url || "/default-avatar.png"}
                      alt={item?.firstName}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                  </div>
                  <div className="ml-3 flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="text-sm font-semibold text-gray-900 truncate">
                        {item?.firstName} {item?.lastName}
                      </h3>
                      <div>
                        <span className="text-xs text-gray-500 font-medium">
                          {e?.lastMessage?.data &&
                            moment(e?.lastMessage?.createdAt).format("h:mm A")}
                        </span>
                        {e?.lastMessage?.data &&
                          e?.lastMessage?.userid !== profile?._id &&
                          !e?.lastMessage?.isRead &&
                          selectedProfile?.roomid !== e?.roomid && (
                            <div
                              className={` w-3 h-3 rounded-full border-2 border-white bg-pink-500`}
                            />
                          )}
                      </div>
                    </div>
                    <p className="text-sm text-gray-600 truncate leading-tight">
                      {e?.lastMessage?.data || "No messages yet"}
                    </p>
                  </div>
                  {e?.unreadCount > 0 && (
                    <div className="ml-2 bg-[#A40165] text-white text-xs rounded-full px-2.5 py-1 min-w-[22px] text-center font-semibold shadow-sm">
                      {e?.unreadCount}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div className="flex items-center justify-center h-full text-gray-500">
              <div className="text-center p-8">
                <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-[#A40165]/10 to-[#A40165]/20 rounded-full flex items-center justify-center">
                  <svg
                    className="w-10 h-10 text-[#A40165]/60"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                    />
                  </svg>
                </div>
                <p className="text-lg font-medium mb-2 text-gray-700">
                  {searchQuery
                    ? "No matching conversations"
                    : "No conversations yet"}
                </p>
                <p className="text-sm text-gray-500">
                  {searchQuery
                    ? "Try adjusting your search terms"
                    : "Start chatting with your clients"}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Right Side - Chat Window */}
      <div className="flex-1 flex flex-col h-full max-h-full min-h-0 ">
        {selectedProfile ? (
          // <div className="h-[70%] md:h-[82vh] sm:h-[62vh] xs:h-[52vh] xl:h-[70vh]">
          <div className="h-full bg-green-500 flex-col flex justify-between">
            {/* Chat Header */}

            <div className="bg-white px-6 py-3 border-b border-gray-200 shadow-sm flex-shrink-0">
              <div className="flex items-center justify-between">
                <button
                  className="md:hidden text-gray-600 hover:text-gray-800 mr-2"
                  onClick={() => setSelectedProfile(null)}
                >
                  ← Back
                </button>
                <div className="flex items-center">
                  <div className="relative">
                    <img
                      src={
                        selectedProfile?.userProfile?.profilePic?.url ||
                        "/default-avatar.png"
                      }
                      alt={selectedProfile?.userProfile?.firstName}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div
                      className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white ${
                        isOnline ? "bg-green-500" : "bg-gray-400"
                      }`}
                    />
                  </div>
                  <div className="ml-3">
                    <h3 className="text-base font-semibold text-gray-900">
                      {selectedProfile?.userProfile?.firstName}{" "}
                      {selectedProfile?.userProfile?.lastName}
                    </h3>
                    <p
                      className={`text-sm ${
                        isOnline ? "text-green-600" : "text-gray-500"
                      }`}
                    >
                      {isOnline ? "Online" : "Offline"}
                    </p>
                  </div>
                </div>
                {/* <HiDotsVertical className="text-gray-400 cursor-pointer hover:text-[#A40165] transition-colors" /> */}
                <Switch
                  checked={toggle}
                  onChange={async () => {
                    setToggle(!toggle);

                    setUsers((prevUsers) =>
                      prevUsers.map((user) =>
                        user.roomid === selectedProfile?.roomid
                          ? { ...user, isActive: !toggle }
                          : user
                      )
                    );
                    socket.emit("change-room-status", {
                      status: !toggle,
                      consultantId: profile?._id,
                      roomId: selectedProfile?.roomid,
                    });
                  }}
                />
              </div>
            </div>
            {/* Messages Container */}
            <div className="flex-1 h-full pb-48 md:pb-10 overflow-y-auto bg-gradient-to-b from-gray-50 to-white px-6 py-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 min-h-0">
              <div className="space-y-4 pb-16">
                {messages?.length > 0 &&
                  messages?.map((e, i) => {
                    const isCurrentUser = e?.userid === profile?._id;
                    return (
                      <div key={i}>
                        {e?.dateChange && (
                          <div className="flex justify-center my-6">
                            <div className="text-xs text-gray-500 bg-white px-4 py-2 rounded-full shadow-md border border-gray-100">
                              {moment(e?.createdAt).format("DD MMM, YYYY")}
                            </div>
                          </div>
                        )}

                        <div
                          className={`flex ${
                            isCurrentUser ? "justify-end" : "justify-start"
                          } mb-2`}
                        >
                          <div
                            className={`max-w-xs lg:max-w-md px-4 py-3 rounded-2xl shadow-md ${
                              isCurrentUser
                                ? "bg-gradient-to-r from-[#A40165] to-[#C41E3A] rounded-br-sm"
                                : "bg-white rounded-bl-sm border border-gray-100"
                            }`}
                          >
                            <p
                              className={`text-sm break-words whitespace-pre-line leading-relaxed ${
                                isCurrentUser ? "text-white" : "text-gray-800"
                              }`}
                            >
                              {e?.data}
                            </p>
                            <div
                              className={`flex items-center justify-end mt-2 text-xs ${
                                isCurrentUser
                                  ? "text-white/80"
                                  : "text-gray-500"
                              }`}
                            >
                              <span
                                className={`font-medium ${
                                  isCurrentUser
                                    ? "text-white/80"
                                    : "text-gray-500"
                                }`}
                              >
                                {moment(e?.createdAt).format("h:mm A")}
                              </span>
                              {isCurrentUser && (
                                <svg
                                  className="w-4 h-4 ml-1 text-white/60"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div ref={messagesEndRef} />
            </div>
            {/* Message Input - Fixed at bottom */}
            <div
              className="fixed inset-x-0 bottom-0     md:static md:pb-6 md:pt-4 bg-white px-4 py-3 sm:px-6 border-t border-gray-200 shadow-lg z-50"
              // This trick applies the safe-area fix ONLY on mobile screens
              style={{
                // Only apply on screens ≤640px (Tailwind's 'sm' breakpoint)
                ...(window.innerWidth <= 640 && {
                  bottom: "max(env(safe-area-inset-bottom), 0px)",
                  paddingBottom: "max(env(safe-area-inset-bottom), 20px)", // ~1.25rem
                }),
              }}
            >
              <div className="flex items-center justify-center   gap-3 sm:gap-4 h-full min-h-10">
                {/* Textarea - takes full width minus button */}
                <div className="flex-1 min-w-0">
                  <textarea
                    ref={textareaRef}
                    value={message}
                    placeholder="Type a message..."
                    onChange={(e) => setmessage(e.target.value)}
                    onKeyDown={handleKeyPress}
                    className="w-full px-4 py-3 max-h-20 bg-gray-50 rounded-2xl resize-none focus:outline-none focus:ring-2 focus:ring-[#A40165] focus:bg-white transition-all border border-gray-200 focus:border-[#A40165]/50 text-gray-800 placeholder-gray-500 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 text-base sm:text-lg leading-relaxed h-14 "
                    rows={1}
                    style={{ fieldSizing: "content" }} // Modern browsers: auto-grow height
                    // Fallback for browsers without field-sizing support
                    // onInput={(e) => {
                    //   e.target.style.height = "auto";
                    //   e.target.style.height = `${e.target.scrollHeight}px`;
                    // }}
                  />
                </div>

                {/* Send Button - fixed width on mobile, slightly larger on tablet+ */}
                <button
                  type="button"
                  onClick={handelsubmit}
                  onMouseDown={(e) => e.preventDefault()}
                  disabled={!message.trim()}
                  className="flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-r from-[#A40165] to-[#C41E3A] text-white rounded-full hover:from-[#C41E3A] hover:to-[#A40165] disabled:bg-gray-300 disabled:cursor-not-allowed transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-110 disabled:transform-none flex-shrink-0 touch-manipulation"
                  aria-label="Send message"
                >
                  <IoSend size={20} className="sm:size-6" />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex-1 flex items-center justify-center bg-gradient-to-br from-gray-50 to-white">
            <div className="text-center text-gray-500 p-8">
              <div className="w-32 h-32 mx-auto mb-6 bg-gradient-to-br from-[#A40165]/10 to-[#A40165]/20 rounded-full flex items-center justify-center shadow-lg">
                <svg
                  className="w-16 h-16 text-[#A40165]/60"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-3 text-gray-700">
                Select a conversation
              </h3>
              <p className="text-gray-500 text-lg">
                Choose a chat from the sidebar to start messaging
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultantChatBox;
